module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/art-logo.e4494692.gif";